<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Rijschool in Rotterdam nodig?</h1>
      <p>
        Als je op zoek bent naar een rijschool in Rotterdam, ben je op
        Rijscholenvergelijker.nl verzekerd van succes. Of je nu graag je
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-b">
          rijbewijs B
        </nuxt-link>
        of je
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-a">
          motorrijbewijs
        </nuxt-link>
        wilt halen óf graag met een aanhanger wilt rijden: op deze website kom
        je gratis én binnen 24 uur in contact met rijscholen in Rotterdam. Zo
        kun je de verschillende rijscholen in jouw omgeving in kaart brengen en
        vergelijken op de belangrijkste punten: welk uurtarief wordt gehanteerd?
        Hoe worden de lessen opgebouwd? Wat is het slagingspercentage? Hoeveel
        uur hebben kandidaten gemiddeld gereden voordat ze slagen voor hun
        praktijkexamen? Biedt de rijschool ook theorielessen aan? Bepaal wat
        voor jou belangrijk is, weeg de plus- en minpunten tegen elkaar af en
        kies de beste rijschool in Rotterdam!
      </p>

      <h2>Simpel, gratis, vrijblijvend</h2>
      <p>
        Het aanvragen van informatie is eenvoudig, helemaal kosteloos en geheel
        vrijblijvend. Je geeft op de website aan om welk rijbewijs het gaat en
        vult enkele gegevens in zoals je naam en je postcode, waardoor wij weten
        dat je naar rijscholen in Rotterdam en omstreken zoekt. Als je de
        aanvraag hebt verstuurd, nemen de rijscholen in jouw regio binnen 24 uur
        contact met je op. Het is dus niet nodig om de rijscholen zelf één voor
        één te benaderen!
      </p>

      <h2>Rijscholen in Rotterdam nu zoeken?</h2>
      <p>
        Laat snel je gegevens achter, laat de
        <nuxt-link to="/"> rijscholen </nuxt-link> in jouw eigen regio snel
        contact met je opnemen en zorg ervoor dat je kiest voor de rijschool in
        Rotterdam die de beste indruk op je achterlaat. Natuurlijk ben je hier
        eveneens aan het goede adres voor
        <nuxt-link to="/informatie-over-rijscholen/amsterdam">
          rijscholen in Amsterdam
        </nuxt-link>
        tot en met
        <nuxt-link to="/informatie-over-rijscholen/eindhoven">
          rijscholen in Eindhoven </nuxt-link
        >. Maak gebruik van deze mooie kans en stap niet in de eerste de beste
        lesauto, maar ga voor de rijschool in Rotterdam die je voor een
        betaalbare prijs goed voorbereidt op je leven achter het stuur!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Rijschool in Rotterdam zoeken? Kijk op Rijscholenvergelijker.nl!',
      headDescription:
        'Zoek je een goede en betaalbare rijschool in Rotterdam? Op Rijscholenvergelijker.nl vraag je gratis offertes aan van rijscholen in Rotterdam!',
    }
  },
}
</script>
